import { render, staticRenderFns } from "./add_distributors.vue?vue&type=template&id=3070e44a&scoped=true&"
import script from "./add_distributors.vue?vue&type=script&lang=js&"
export * from "./add_distributors.vue?vue&type=script&lang=js&"
import style0 from "./add_distributors.vue?vue&type=style&index=0&lang=css&"
import style1 from "./add_distributors.vue?vue&type=style&index=1&id=3070e44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3070e44a",
  null
  
)

export default component.exports